import * as React from "react";
import ImageView from "../../../components/SmartImage";
import ViewMoreCard from "../../components/ViewMoreCard";
import { ViewMoreBox, RollOverContainer } from "./styles";
import { isNotBlankArray } from "../../../utils/array";
import { LinkTargetType } from "../../../services/playground";
class RollOver extends React.Component {
    render() {
        const { cardBanners, viewMore, positionId, placeholderBg, aTarget = LinkTargetType.Blank } = this.props;
        if (!isNotBlankArray(cardBanners)) {
            return null;
        }
        const oneItem = cardBanners[0];
        return (React.createElement(RollOverContainer, { "data-id": positionId, id: positionId, style: { height: oneItem.height ? `calc(${oneItem.height} * 0.36)` : "auto" } },
            (cardBanners || []).map((item, index) => (React.createElement("a", Object.assign({}, (item.link ? { href: item.link, target: aTarget } : {}), { key: index }),
                React.createElement(ImageView, { src: item.img, aliSize: 2, qnParams: { w: 135 }, isLazyLoad: false, online: this.props.online, placeholder: placeholderBg, fallbackSrc: placeholderBg })))),
            viewMore && (React.createElement(ViewMoreCard, { StyledComponent: ViewMoreBox, link: viewMore.link, text: viewMore.text }))));
    }
}
export default RollOver;
